import {inject, Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from '../../environments/environment';
import {CostCalculationSettings} from '../shared/model/cost-calculation.model';

/**
 * Zugriff auf die zentralen Parameter der Satzberechnung (NP20-933).
 *
 * `GET` steht Admin und Office offen, `PUT` nur Admin — das erzwingt das
 * Backend, das Modal spiegelt es nur.
 */
@Injectable({providedIn: 'root'})
export class CostCalculationService {
  private readonly http = inject(HttpClient);

  readonly resourceUrl = environment.apiConfig.uri + 'api/settings/cost-calculation';

  getSettings(): Observable<CostCalculationSettings> {
    return this.http.get<CostCalculationSettings>(this.resourceUrl);
  }

  saveSettings(settings: CostCalculationSettings): Observable<CostCalculationSettings> {
    return this.http.put<CostCalculationSettings>(this.resourceUrl, settings);
  }
}
